import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { PropertyHistoryEntry } from './models/property-history-entry';
import { MatExpansionPanel } from '@angular/material/expansion';

@Component({
  selector: '[appPropertyWithHistory]',
  templateUrl: './property-with-history.component.html',
  standalone: false,
})
export class PropertyWithHistoryComponent {
  @Input() label: string;
  @Input() currentValue: string;
  @Input() history: PropertyHistoryEntry[] | null = null;
  @Input() showHistory = true;

  @ViewChild('panel') panel: MatExpansionPanel;
  @Output() annexClick = new EventEmitter<number>();

  get hasHistory(): boolean {
    return this.showHistory && !!this.history && this.history.length > 1;
  }

  togglePanel(): void {
    this.panel?.toggle();
  }

  onAnnexClick(event: Event, entry: PropertyHistoryEntry): void {
    event.stopPropagation();
    if (entry.annexId) {
      this.annexClick.emit(entry.annexId);
    }
  }
}
